<template>
  <div class="container mx-auto">
    <slot />
  </div>
</template>
